import { useContext } from "react";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { makeQueryString } from "core/makeQueryString";
import { SitesResponse } from "interfaces/site";
import { AxiosContext } from "contexts/AxiosContext";

const STALE_TIME = 1000 * 60 * 15;

export const useSitesQuery = (
  page = 1,
  pageSize = 10000
): UseQueryResult<SitesResponse, unknown> => {
  const { axios } = useContext(AxiosContext)!;
  const queryString = makeQueryString({ page, size: pageSize });

  return useQuery({
    queryKey: ["sites", queryString],
    queryFn: async () => {
      const { data } = await axios.get<SitesResponse>(`/sites${queryString}`);

      return data;
    },
    staleTime: STALE_TIME
  });
};
